var cov_3r0tu13e5 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Upload/ImageFile.tsx",
      hash = "f4f827fe3f7ca1be63a87fe6820420807a84a528",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Upload/ImageFile.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 4
        },
        end: {
          line: 10,
          column: 16
        }
      },
      "1": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 52
        }
      },
      "2": {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 15,
          column: 38
        }
      },
      "3": {
        start: {
          line: 19,
          column: 54
        },
        end: {
          line: 19,
          column: 64
        }
      },
      "4": {
        start: {
          line: 20,
          column: 22
        },
        end: {
          line: 20,
          column: 76
        }
      },
      "5": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 40,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 3
          }
        },
        loc: {
          start: {
            line: 9,
            column: 37
          },
          end: {
            line: 12,
            column: 3
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 14,
            column: 3
          }
        },
        loc: {
          start: {
            line: 14,
            column: 17
          },
          end: {
            line: 16,
            column: 3
          }
        },
        line: 14
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 3
          }
        },
        loc: {
          start: {
            line: 18,
            column: 11
          },
          end: {
            line: 41,
            column: 3
          }
        },
        line: 18
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 20,
            column: 48
          },
          end: {
            line: 20,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 48
          },
          end: {
            line: 20,
            column: 64
          }
        }, {
          start: {
            line: 20,
            column: 68
          },
          end: {
            line: 20,
            column: 75
          }
        }],
        line: 20
      },
      "1": {
        loc: {
          start: {
            line: 24,
            column: 9
          },
          end: {
            line: 24,
            column: 110
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 24,
            column: 9
          },
          end: {
            line: 24,
            column: 13
          }
        }, {
          start: {
            line: 24,
            column: 17
          },
          end: {
            line: 24,
            column: 110
          }
        }],
        line: 24
      },
      "2": {
        loc: {
          start: {
            line: 26,
            column: 9
          },
          end: {
            line: 26,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 26,
            column: 9
          },
          end: {
            line: 26,
            column: 16
          }
        }, {
          start: {
            line: 26,
            column: 20
          },
          end: {
            line: 26,
            column: 75
          }
        }],
        line: 26
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Upload/ImageFile.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import Progress from '../Progress';
import { uploadClass } from './styles';
import Image from '../Image';
import { ERROR } from './request';

var ImageFile =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ImageFile, _PureComponent);

  var _super = _createSuper2(ImageFile);

  function ImageFile(props) {
    var _this;

    _classCallCheck(this, ImageFile);

    cov_3r0tu13e5.f[0]++;
    cov_3r0tu13e5.s[0]++;
    _this = _super.call(this, props);
    cov_3r0tu13e5.s[1]++;
    _this.handleRemove = _this.handleRemove.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ImageFile, [{
    key: "handleRemove",
    value: function handleRemove() {
      cov_3r0tu13e5.f[1]++;
      cov_3r0tu13e5.s[2]++;
      this.props.onRemove(this.props.id);
    }
  }, {
    key: "render",
    value: function render() {
      cov_3r0tu13e5.f[2]++;

      var _ref = (cov_3r0tu13e5.s[3]++, this.props),
          process = _ref.process,
          status = _ref.status,
          style = _ref.style,
          data = _ref.data,
          message = _ref.message;

      var className = (cov_3r0tu13e5.s[4]++, uploadClass('image-item', (cov_3r0tu13e5.b[0][0]++, status === ERROR) && (cov_3r0tu13e5.b[0][1]++, 'error')));
      cov_3r0tu13e5.s[5]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          style: style,
          className: className,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 23,
            columnNumber: 7
          }
        }, (cov_3r0tu13e5.b[1][0]++, data) && (cov_3r0tu13e5.b[1][1]++,
        /*#__PURE__*/
        React.createElement(Image, {
          src: data,
          fit: "center",
          width: "auto",
          height: 0,
          className: uploadClass('image-bg'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 24,
            columnNumber: 18
          }
        })), (cov_3r0tu13e5.b[2][0]++, message) && (cov_3r0tu13e5.b[2][1]++,
        /*#__PURE__*/
        React.createElement("div", {
          className: uploadClass('message'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 26,
            columnNumber: 21
          }
        }, message)),
        /*#__PURE__*/
        React.createElement("span", {
          className: uploadClass('delete'),
          onClick: this.handleRemove,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 28,
            columnNumber: 9
          }
        }),
        /*#__PURE__*/
        React.createElement("div", {
          className: uploadClass('progress-bg'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 30,
            columnNumber: 9
          }
        },
        /*#__PURE__*/
        React.createElement(Progress, {
          className: uploadClass('progress'),
          color: "#f2f2f2",
          background: "rgba(0,0,0,0.5)",
          value: process,
          strokeWidth: 2,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 31,
            columnNumber: 11
          }
        })))
      );
    }
  }]);

  return ImageFile;
}(PureComponent);

export default ImageFile;